export default "__VITE_ASSET__Dj$RAiDi__"